import { CommandParser } from '../client/parser';
import { RedisArgument, NumberReply, Command } from '../RESP/types';

/**
 * Command for removing a consumer group
 */
export default {
  parseCommand(parser: CommandParser, key: RedisArgument, group: RedisArgument) {
    parser.push('XGROUP', 'DESTROY');
    parser.pushKey(key);
    parser.push(group);
  },
  transformReply: undefined as unknown as () => NumberReply
} as const satisfies Command;
